import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

// Thunk: Delete level by ID
export const deletelevel = createAsyncThunk(
  "levels/deletelevel",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${apiUrl}/UserLevels/${id}/`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return id; // Return the ID of the deleted level
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || "Failed to delete level"
      );
    }
  }
);

const levelSlice = createSlice({
  name: "levels",
  initialState: {
    userLevels: [], // Store for all levels
    deleteStatus: "idle", // Status for delete operation
    deleteError: null, // Error for delete operation
  },
  reducers: {
    resetDeleteStatus: (state) => {
      state.deleteStatus = "idle";
      state.deleteError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle deletelevel action
      .addCase(deletelevel.pending, (state) => {
        state.deleteStatus = "loading";
        state.deleteError = null;
      })
      .addCase(deletelevel.fulfilled, (state, action) => {
        state.deleteStatus = "succeeded";
        state.levels = state.levels.filter((level) => level.id !== action.payload);
      })
      .addCase(deletelevel.rejected, (state, action) => {
        state.deleteStatus = "failed";
        state.deleteError = action.payload;
      });
  },
});

export const { resetDeleteStatus } = levelSlice.actions;

export default levelSlice.reducer;
